import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { history } from 'routes/history';
import classNames from 'classnames';
import Storage from 'utilities/storage';
import validator from 'validator';
import PropTypes from 'prop-types';
import { FormattedText, formatText, getLanguage } from 'core/i18n';
import { actions as formActions } from 'react-redux-form';
import optionsActions from 'actions/optionsActions';
import stepsActions from 'actions/stepsActions';
import identityValidationActions from 'actions/identityValidationActions';
import GeoAddress from 'components/GeoAddress';
import GeoSelect from 'components/GeoAddress/GeoFields/GeoSelect';
import GeoInput from 'components/GeoAddress/GeoFields/GeoInput';
import GeoRowGroup from 'components/GeoAddress/GeoRowGroup';
import { DocumentationRequired } from './documentationRequired';
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import getEncrypted from 'utilities/getEncrypted';
import tools from 'utilities/tools';
import addressHelper from 'utilities/addressHelper/addressHelper';
import scroll from 'utilities/scroll';
import { showDependsOnTwoFlags } from 'utilities/flags';
import { recordEvent, RELIABLE, errorTag, PAGE_PRODUCT } from 'utilities/uTagging';
import {
    PATH_IDENTITY,
    PATH_IDENTITY_COURIER,
    PATH_IDENTITY_COURIER_EVENT,
    PATH_IDENTITY_COURIER_SCHEDULE,
} from 'constants/uTagConstants/paths';
import { ALLOW_COOKIE } from 'constants/index';
import { ERROR_CASO_EN_DOMICILIO } from 'constants/analyticsErrors';
import { PHYSICALIDEN, COURIER } from 'constants/featureFlagging';
import { EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import { isMobile } from 'utilities/browser';
import {
    formatDateToYYYYMMDD,
    getDayNameFromDate,
    getMonthNameFromDate,
    getAmPm,
    getDay,
} from 'utilities/dateHelper/dateHelper';

class CourierIdentification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courierDescription: false,
            modifyAddress: false,
            showAvailableDays: true,
            days: [],
            toSchedule: false,
            errorType: '',
            showGreyBox: true,
        };
    }

    UNSAFE_componentWillMount() {
        const { userProfile } = this.props;
        this.getAvailableDaysByPostalCode(userProfile.postalCode);
    }

    componentDidMount() {
        const { userProfile, method } = this.props,
            identitybuttonElement = document.getElementById('identityButton');

        recordEvent(
            PATH_IDENTITY_COURIER,
            PAGE_PRODUCT,
            PATH_IDENTITY_COURIER_EVENT,
            'mensajero',
            userProfile.recordId,
            userProfile.userId,
            '',
            userProfile.investmentType,
            getEncrypted(userProfile.docNumber),
            {
                categoriaEvento: EVENT_ONBOARDING,
                accionEvento: PATH_IDENTITY_COURIER_EVENT,
                etiquetaEvento: 'mensajero',
            }
        );

        this.resetAlternateAddressFields();

        if (isMobile() && method !== '') {
            scroll.transition(identitybuttonElement, 'percentage', 0.7, 500);
        }
    }

    getAvailableDaysByPostalCode = postalCode => {
        const { formActions } = this.props;
        let errorType = '',
            days;

        const leaveDays = this.getLeaveDays(postalCode);

        if (leaveDays != null) {
            days = this.getFillDays(leaveDays);
        } else {
            formActions.change('userProfile.dateToVisit', null);
            days = [];
            errorType = 'courierWithoutScope';
        }

        this.setState({
            days,
            errorType,
        });
    };

    resetAlternateAddressFields = () => {
        //Prefill all fields in alternate address
        const { userProfile, formActions } = this.props;

        const fields = [
            'address',
            'typeOfRoad',
            'nameOfRoad',
            'addressNumber',
            'additionalInfo',
            'postalCode',
            'town',
            'province',
            'country',
        ];

        if (userProfile.address_has_cache === true) {
            fields.forEach(field => {
                formActions.change(`userProfile.${field}_2`, tools.getValueOrDefault(userProfile[`${field}_2_cache`]));
            });
        } else {
            fields.forEach(field => {
                if (tools.isEmptyOrWhitespace(userProfile[`${field}_2`])) {
                    formActions.change(`userProfile.${field}_2`, tools.getValueOrDefault(userProfile[field]));
                }
            });
            // Create a cache of last addresses
            formActions.change('userProfile.address_has_cache', true);
            fields.forEach(field => {
                formActions.change(`userProfile.${field}_2_cache`, tools.getValueOrDefault(userProfile[field]));
            });
        }
    };

    handleSaveModifiedAddress = () => {
        const areValidFields = this.validateCourierFields();
        if (areValidFields) {
            const { userProfile, formActions, identityValidationActions, options } = this.props;
            const fields = [
                'typeOfRoad_2',
                'nameOfRoad_2',
                'addressNumber_2',
                'additionalInfo_2',
                'postalCode_2',
                'town_2',
                'province_2',
                'country_2',
            ];

            const formattedAddress = this.getGenerateFormattedAddress(userProfile, options);
            formActions.change(`userProfile.address_2`, formattedAddress);

            // Update the cache of last addresses
            formActions.change(`userProfile.address_2_cache`, formattedAddress);

            fields.forEach(field => {
                formActions.change(`userProfile.${field}_cache`, tools.getValueOrDefault(userProfile[field]));
            });

            const addressFields = [
                'typeOfRoad',
                'nameOfRoad',
                'addressNumber',
                'additionalInfo',
                'postalCode',
                'town',
                'province',
                'country',
            ];
            const address = addressFields.reduce((accumulator, field) => {
                accumulator[field] = tools.getValueOrDefault(userProfile[`${field}_2`], ' '); //Server-side DTO expects at least 1 space on empty fields.

                return accumulator;
            }, {});

            identityValidationActions.saveCourierAddress(address, userProfile.accessToken, (saved, error) => {
                if (!saved) {
                    errorTag(error.body, PATH_IDENTITY_COURIER, ERROR_CASO_EN_DOMICILIO, error.statusCode);
                }
            });
            this.getAvailableDaysByPostalCode(this.props.userProfile.postalCode_2);
            this.setState({ modifyAddress: false, showAvailableDays: true });

            const mapElement = document.getElementById('courierContent');
            scroll.transition(mapElement, 'top', 1, 500);
        }
    };

    validateCourierFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = [
            'address_2',
            'typeOfRoad_2',
            'addressNumber_2',
            'nameOfRoad_2',
            'postalCode_2',
            'province_2',
        ];
        const requiredFlag = requiredFields.some(field => !userProfileForm[field].valid);

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (!userProfileForm[field].valid) {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    getGenerateFormattedAddress = (userProfile, options) => {
        const { nameOfRoad_2, addressNumber_2, postalCode_2, town_2, province_2, country_2 } = userProfile;

        return addressHelper.generateFormattedAddress(
            nameOfRoad_2,
            addressNumber_2,
            postalCode_2,
            town_2,
            province_2,
            country_2,
            options.get('cities'),
            options.get('countries')
        );
    };

    handleCheckValidPostalCode = field => {
        const { userProfile, formActions } = this.props;
        if (
            (field === 'province_2' || field === 'postalCode_2') &&
            !tools.isEmptyOrWhitespace(userProfile.postalCode_2) &&
            !tools.isEmptyOrWhitespace(userProfile.province_2)
        ) {
            formActions.setValidity('userProfile.postalCode_2', {
                zip: userProfile.postalCode_2.startsWith(userProfile.province_2),
            });
        }
    };

    resetAlternateAddressFields = () => {
        //Prefill all fields in alternate address
        const { userProfile, formActions } = this.props;

        const fields = [
            'address',
            'typeOfRoad',
            'nameOfRoad',
            'addressNumber',
            'additionalInfo',
            'postalCode',
            'town',
            'province',
            'country',
        ];

        if (userProfile.address_has_cache === true) {
            fields.forEach(field => {
                formActions.change(`userProfile.${field}_2`, tools.getValueOrDefault(userProfile[`${field}_2_cache`]));
            });
        } else {
            fields.forEach(field => {
                if (tools.isEmptyOrWhitespace(userProfile[`${field}_2`])) {
                    formActions.change(`userProfile.${field}_2`, tools.getValueOrDefault(userProfile[field]));
                }
            });
            // Create a cache of last addresses
            formActions.change('userProfile.address_has_cache', true);
            fields.forEach(field => {
                formActions.change(`userProfile.${field}_2_cache`, tools.getValueOrDefault(userProfile[field]));
            });
        }
    };

    handleResetAlternateAddressFields = () => {
        this.resetAlternateAddressFields();

        const fields = [
            'address',
            'typeOfRoad',
            'nameOfRoad',
            'addressNumber',
            'additionalInfo',
            'postalCode',
            'town',
            'province',
            'country',
        ];

        fields.forEach(field => {
            this.props.formActions.setValidity(`userProfile.${field}_2`, true);
        });

        this.setState({ modifyAddress: false, showAvailableDays: true });

        const mapElement = document.getElementById('courierContent');
        scroll.transition(mapElement, 'top', 1, 500);
    };

    getLeaveDays = postalCode => {
        let leaveDays = 1;

        if (postalCode.startsWith('07')) {
            leaveDays = 2;
        }
        if (postalCode.startsWith('35') || postalCode.startsWith('38')) {
            leaveDays = 3;
        }
        if (postalCode === '' || postalCode.startsWith('51') || postalCode.startsWith('52')) {
            leaveDays = null;
        }

        return leaveDays;
    };

    getDay = () => {
        let day = new Date(this.props.options.get('serverDate'));

        if (ALLOW_COOKIE && Storage.cookies.get('date')) {
            day = new Date(Storage.cookies.get('date'));
        }

        return day;
    };

    getCookieHour = hour => {
        let cookieHour = hour;

        if (ALLOW_COOKIE && Storage.cookies.get('hour')) {
            cookieHour = parseInt(Storage.cookies.get('hour'));
        }

        return cookieHour;
    };

    getFillDays = leaveDays => {
        let dayName,
            day = this.getDay(),
            laboralDaysCounter = 0;

        const days = [];
        const hour = day.getHours();
        const amPm = getAmPm(day);
        const cookieHour = this.getCookieHour(hour);
        const AVAILABLE_LABORAL_DAYS_TO_SHOW = 6;

        if (this.isMoreThanFiveOclock(hour, cookieHour, amPm)) {
            leaveDays++;
        }

        while (laboralDaysCounter < AVAILABLE_LABORAL_DAYS_TO_SHOW) {
            dayName = getDayNameFromDate(day, 'en');
            if (dayName !== 'Saturday' && dayName !== 'Sunday') {
                if (leaveDays === 0) {
                    this.handleDateToVisit(day, laboralDaysCounter);
                    days[laboralDaysCounter] = {
                        dayNumber: String(getDay(day)).padStart(2, '0'),
                        dayName: formatText(`daysOfWeek-${dayName.toLowerCase()}`),
                        monthName: formatText(`months-${getMonthNameFromDate(day, 'en').toLowerCase()}`),
                        date: formatDateToYYYYMMDD(day, ''),
                    };
                    laboralDaysCounter++;
                } else {
                    leaveDays--;
                }
            }
            day = day.add(1, 'days');
        }

        return days;
    };

    isMoreThanFiveOclock = (hour, cookieHour, amPm) => {
        return (hour >= 5 && amPm === 'pm') || cookieHour >= 17;
    };

    handleDateToVisit = (day, numOfDay) => {
        const { userProfile, formActions } = this.props;
        if (
            numOfDay === 0 &&
            (typeof userProfile.dateToVisit === 'undefined' ||
                userProfile.dateToVisit === null ||
                userProfile.dateToVisit !== formatDateToYYYYMMDD(day, ''))
        ) {
            formActions.change('userProfile.dateToVisit', formatDateToYYYYMMDD(day, ''));
        }
    };

    getAvailableDays = () => {
        const greyBox = this.state.showGreyBox ? this.buildGreyBoxMessage() : null;
        const daysView = [];

        if (this.state.days.length > 0) {
            let i;
            for (i = 0; i < this.state.days.length; i++) {
                daysView[i] = this.renderDayCard(this.state.days[i]);
            }

            return (
                <div>
                    <h4 className="form__group-title">
                        <FormattedText value="identity-dates" />
                    </h4>
                    <p className="font-paragraph2">
                        <FormattedText value="identity-selectDate" />
                    </p>
                    <div className="courier-content__days">
                        <div className="courier-content__days--scroll">
                            <div className="courier-content__days--content">{daysView}</div>
                        </div>
                    </div>
                    {greyBox}
                    <button type="submit" className="form__button form__button-secondary">
                        <FormattedText value="button-confirmSchedule" />
                    </button>
                </div>
            );
        }
        const containerClass = classNames({
            alert: true,
            'alert-danger-courier': this.state.errorType === 'courierWithoutScope',
            'alert-danger': this.state.errorType !== 'courierWithoutScope',
        });

        return (
            <div className={containerClass}>
                <span className="icons icons--icon-alert-msg"></span>
                <FormattedText value={`alerts-${this.state.errorType}`} />
                {formatText()}
            </div>
        );
    };

    renderDayCard = day => {
        const { userProfile } = this.props;
        const { date, dayName, dayNumber, monthName } = day;
        const classDay =
            userProfile.dateToVisit === date
                ? 'courier-content__days__day courier-content__days__day--active'
                : 'courier-content__days__day';

        return (
            <div
                className={classDay}
                key={date}
                onClick={() => {
                    this.onHandleChangeDateToVisit(date);
                }}
            >
                <div>
                    <h6 className="courier-content__days__day__title">{dayName}</h6>
                    <p className="courier-content__days__day__date">
                        <FormattedText value="identity-date" injectedStrings={[dayNumber, monthName]} />
                    </p>
                </div>
            </div>
        );
    };

    onHandleChangeDateToVisit = date => {
        const { formActions } = this.props;
        formActions.change('userProfile.dateToVisit', date);
        this.handleShowGreyBox();
    };

    handletoSchedule = () => {
        const { userProfile } = this.props;
        recordEvent(
            PATH_IDENTITY_COURIER_SCHEDULE,
            PAGE_PRODUCT,
            'identidad',
            'mensajero-agendar',
            userProfile.recordId,
            userProfile.userId,
            '',
            userProfile.investmentType,
            getEncrypted(userProfile.docNumber)
        );

        this.setState({
            toSchedule: true,
        });

        const mapElement = document.getElementById('courierContent');
        scroll.transition(mapElement, 'top', 1, 500);
    };

    handleModifyAddress = () => {
        this.setState({
            modifyAddress: true,
            showAvailableDays: false,
        });
    };

    handleSubmit = () => {
        const { userProfile, identityValidationActions, options, formActions } = this.props;
        const date = `${userProfile.dateToVisit.slice(6, 8)}/${userProfile.dateToVisit.slice(
            4,
            6
        )}/${userProfile.dateToVisit.slice(0, 4)}`;

        // NOTA: se esta usando un valor default de 1 espacio si no existe valor porque el DTO serverside esta esperando
        //       al menos un caracter en la llamada, esto es especialmente cierto con el town que en FE es opcional pero
        //       en BE es mandatorio. (El cambio a opcional en FE creo que es un cambio reciente)
        const courierData = {
            address: {
                additionalInfo: tools.getValueOrDefault(userProfile.additionalInfo_2, ' '),
                addressNumber: tools.getValueOrDefault(userProfile.addressNumber_2, ' '),
                nameOfRoad: tools.getValueOrDefault(userProfile.nameOfRoad_2, ' '),
                postalCode: tools.getValueOrDefault(userProfile.postalCode_2, ' '),
                town: tools.getValueOrDefault(userProfile.town_2, ' '),
                country: tools.getValueOrDefault(userProfile.country_2, ' '),
            },
            date,
        };

        if (courierData.address.country === '') {
            courierData.address.country = getReferenceCodeByCountry().toUpperCase();
        }

        const formattedAddress = this.getGenerateFormattedAddress(userProfile, options);

        formActions.change('userProfile.courierAddress', formattedAddress);
        formActions.change('userProfile.courierAddressInfo', userProfile.additionalInfo_2);

        identityValidationActions.clientIdentificationCourier(
            courierData,
            userProfile.accessToken,
            (identified, error) => {
                if (!identified) {
                    let pageToRedirect = '';
                    if (error.body.errors['8030']) {
                        pageToRedirect = '/steps';
                    } else {
                        pageToRedirect = '/errors';
                    }
                    errorTag(error.body, PATH_IDENTITY_COURIER, ERROR_CASO_EN_DOMICILIO, error.statusCode);
                    history.push(pageToRedirect);
                }
            }
        );
        formActions.change('userProfile.identified', true);
        recordEvent(
            PATH_IDENTITY,
            PAGE_PRODUCT,
            'validacion por mensajero',
            'validacion por mensajero correcto',
            userProfile.recordId,
            userProfile.userId,
            RELIABLE['courier'],
            userProfile.investmentType,
            getEncrypted(userProfile.docNumber)
        );

        this.setState({
            modifyAddress: false,
            showAvailableDays: true,
        });
    };

    buildGreyBoxMessage = () => {
        return (
            <div className="grey-box">
                <i className="icons icons--yellow-icon-exclamation"></i>
                <p className="font-paragraph2">
                    <FormattedText value="identity-courierDisclaimer" />
                </p>
            </div>
        );
    };

    handleShowGreyBox = () => {
        this.setState({
            showGreyBox: true,
        });
    };

    getAddress = () => tools.getValueOrDefault(this.props.userProfile.address_2);

    isFilledAddress = () => !!this.props.userProfile.address_2Filled;

    buildGeoAddress = () => {
        if (!this.state.modifyAddress) return null;

        return (
            <GeoAddress
                baseModelDescriptor="userProfile"
                baseModelProperty="address_2"
                baseModelForm={this.props.userProfileForm}
                onUpdate={this.handleSaveAddressInformation}
                value={this.props.userProfile.address_2}
                id="addressAutocomplete"
                isFilled={this.isFilledAddress}
                language={getLanguage()}
            >
                <GeoRowGroup>
                    <GeoSelect
                        id="typeOfRoad"
                        baseModelProperty="typeOfRoad_2"
                        gmapsType="type_of_road"
                        options={this.props.options.get('typesOfRoads').toJS()}
                        value={this.props.userProfile.typeOfRoad_2}
                        label={formatText('field-typeOfRoad')}
                        size={4}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                        }}
                    />
                    <GeoInput
                        id="nameOfRoad"
                        baseModelProperty="nameOfRoad_2"
                        gmapsType="route"
                        value={this.props.userProfile.nameOfRoad_2}
                        label={formatText('field-nameOfRoad')}
                        size={8}
                        maxLength={45}
                        placeholder={formatText('field-nameOfRoad')}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                            valid: value => {
                                //FIXME: ^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$
                                return (
                                    !tools.isEmptyOrWhitespace(value) &&
                                    validator.matches(
                                        value.toString(),
                                        /^[A-Z0-9À-ÿ_./\\?,:;'-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]+$/i
                                    ) &&
                                    value.length <= 45
                                );
                            },
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-syntaxError'),
                        }}
                    />
                </GeoRowGroup>
                <GeoRowGroup>
                    <GeoInput
                        id="addressNumber"
                        baseModelProperty="addressNumber_2"
                        gmapsType="street_number"
                        value={this.props.userProfile.addressNumber_2}
                        label={formatText('field-number')}
                        size={4}
                        placeholder={formatText('field-number')}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                            valid: value => {
                                return (
                                    !tools.isEmptyOrWhitespace(value) &&
                                    validator.matches(value.toString(), /^S\/N$|^s\/n$|^[0-9]{1,3}/) &&
                                    value.length <= 3
                                );
                            },
                        }}
                        errorMessages={{
                            required: formatText('validation-numberRequired'),
                            valid: formatText('validation-numberNoValid'),
                        }}
                    />
                    <GeoInput
                        id="additionalInfo"
                        baseModelProperty="additionalInfo_2"
                        gmapsType="additional_info"
                        value={this.props.userProfile.additionalInfo_2}
                        label={formatText('field-additionalInfo')}
                        size={8}
                        maxLength={50}
                        placeholder={formatText('field-additionalInfo')}
                        validators={{
                            valid: value => {
                                //FIXME: ^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$
                                return (
                                    tools.isEmptyOrWhitespace(value) ||
                                    (validator.matches(
                                        value.toString(),
                                        /^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$/i
                                    ) &&
                                        value.length <= 40) ||
                                    true
                                );
                            },
                        }}
                        errorMessages={{
                            valid: formatText('validation-syntaxError'),
                        }}
                    />
                </GeoRowGroup>
                <GeoRowGroup>
                    <GeoInput
                        id="postalCode"
                        baseModelProperty="postalCode_2"
                        gmapsType="postal_code"
                        value={this.props.userProfile.postalCode_2}
                        label={formatText('field-postalCode')}
                        size={4}
                        maxLength={5}
                        placeholder={formatText('field-postalCode')}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                            valid: value => {
                                return (
                                    !tools.isEmptyOrWhitespace(value) &&
                                    validator.isInt(value.toString(), { min: 0, allow_leading_zeroes: true })
                                );
                            },
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-syntaxError'),
                            zip: formatText('validation-postalCodeServer'),
                        }}
                        onUpdate={this.handleCheckValidPostalCode}
                    />
                    <GeoInput
                        id="town"
                        baseModelProperty="town_2"
                        gmapsType="town"
                        value={this.props.userProfile.town_2}
                        label={formatText('field-town')}
                        size={4}
                        maxLength={40}
                        placeholder={formatText('field-town')}
                        validators={{
                            valid: value => {
                                return (
                                    tools.isEmptyOrWhitespace(value) ||
                                    (validator.matches(value.toString(), /^[a-zA-ZÀ-ÿ'\s\u005B\u005D]+$/) &&
                                        value.length <= 40)
                                );
                            },
                        }}
                        errorMessages={{
                            valid: formatText('validation-syntaxError'),
                        }}
                    />
                    <GeoSelect
                        id="province"
                        baseModelProperty="province_2"
                        gmapsType="administrative_area_level_2"
                        options={this.props.options.get('cities').toJS()}
                        value={this.props.userProfile.province_2}
                        label={formatText('field-province')}
                        size={4}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                            zip: formatText('validation-postalCodeServer'),
                        }}
                        onUpdate={this.handleCheckValidPostalCode}
                    />
                </GeoRowGroup>
                <GeoInput
                    id="country"
                    baseModelProperty="country_2"
                    gmapsType="country"
                    value={this.props.userProfile.country_2}
                    size={0}
                />
            </GeoAddress>
        );
    };

    render() {
        const daysListView = this.getAvailableDays();
        const classButtonOthers = this.state.toSchedule
            ? 'hidden'
            : 'form__button form__button-secondary visible-others';
        const classButtonMobile = this.state.toSchedule
            ? 'hidden'
            : 'form__button form__button-secondary visible-mobile';
        const address = this.getAddress();

        return (
            <div className="courier-content">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <FeatureTogglingRender
                            notAllowedProductKey={flags => showDependsOnTwoFlags(flags, PHYSICALIDEN, COURIER)}
                        >
                            <p className="font-heading6">
                                <FormattedText value="identity-sendHome" />
                            </p>
                        </FeatureTogglingRender>
                        <p className="font-paragraph2">
                            <FormattedText value="identification-courierDescription1" />
                        </p>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <p className="font-paragraph2 font-paragraph2--semibold">
                            {formatText('identity-courierValidation')}
                        </p>
                        <DocumentationRequired />
                        <button
                            type="button"
                            id="identityButton"
                            onClick={this.handletoSchedule}
                            className={classButtonMobile}
                        >
                            <FormattedText value="button-toSchedule" />
                        </button>
                    </div>
                </div>
                <div>
                    <button type="button" onClick={this.handletoSchedule} className={classButtonOthers}>
                        <FormattedText value="button-toSchedule" />
                    </button>
                </div>
                <div style={{ display: this.state.toSchedule ? 'block' : 'none' }} className="courier__details">
                    <Form model="userProfile" onSubmit={this.handleSubmit}>
                        <div className="courier-content__box" id="courierContent">
                            <h4 className="form__group-title">
                                <FormattedText value="identity-indicatesAddress" format="uppercase" />
                            </h4>
                            <div
                                className="md-form-group container"
                                style={{ display: this.state.modifyAddress ? 'none' : 'block' }}
                            >
                                <div className="row">
                                    <div className="col-xs-9 col-sm-10 courier-content__input-address">
                                        <div className="form__input">
                                            <label>
                                                <FormattedText value="identity-address" />
                                            </label>
                                            <input
                                                type="text"
                                                name="address"
                                                value={address}
                                                readOnly="true"
                                                onClick={this.handleModifyAddress}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-sm-2 courier-content__edit-address">
                                        <a
                                            className="hover-tooltip"
                                            href="#"
                                            onClick={event => {
                                                event.preventDefault();
                                                this.handleModifyAddress();
                                            }}
                                        >
                                            <span className="hover-tooltip__text">
                                                <FormattedText value="tooltip-edit" />
                                            </span>
                                            <span className="icons icons--icon-edit"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: this.state.modifyAddress ? 'block' : 'none' }}>
                                <div className="form__input">
                                    <label>
                                        <FormattedText value="identity-address" />
                                    </label>
                                    {this.buildGeoAddress()}
                                </div>
                                <div className="col-xs-12 form__buttons">
                                    <button
                                        type="button"
                                        className="form__button form__button-primaryB form__button-primaryB--reverse"
                                        style={{ marginRight: '15px' }}
                                        onClick={this.handleResetAlternateAddressFields}
                                    >
                                        {formatText('identity-courierCancelButton')}
                                    </button>
                                    <button
                                        type="button"
                                        className="form__button form__button-primaryB"
                                        onClick={this.handleSaveModifiedAddress}
                                    >
                                        {formatText('identity-saveCancelButton')}
                                    </button>
                                </div>
                            </div>
                            <div style={{ display: this.state.showAvailableDays ? 'block' : 'none' }}>
                                {daysListView}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

module.exports.constructor = CourierIdentification;
module.exports.CourierIdentification = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        identityValidationActions: bindActionCreators(identityValidationActions, dispatch),
    })
)(CourierIdentification);

CourierIdentification.defaultProps = {
    method: '',
};

CourierIdentification.propTypes = {
    method: PropTypes.string,
};
